module.exports = __webpack_public_path__ + "img/tst_rwth_logo.89466bb1.png";